import React, { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import HomeIcon from "../assets/svg/HomeIcon";
import OrdersIcon from "../assets/svg/OrdersIcon";
import ProfileIcon from "../assets/svg/ProfileIcon";
import FacebookIcon from "../assets/svg/FacebookIcon";
import InstagramIcon from "../assets/svg/InstagramIcon";
import YoutubeIcon from "../assets/svg/YoutubeIcon";
import PinterestIcon from "../assets/svg/PinterestIcon";
import ExitIcon from "../assets/svg/ExitIcon";
import useAuth from "../hooks/useAuth";
import BootstrapLoader from "../components/utils/BootstrapLoader";
import AccountLogin from "../components/utils/AccountLogin";

const Profile = () => {
  const { token, user, logout, authLoading } = useAuth();
  const menuItems = [
    {
      path: "dashboard",
      label: "Dashboard",
      icon: <HomeIcon width={18} height={18} color="white" />,
    },
    {
      path: "orders",
      label: "My Orders",
      icon: <OrdersIcon width={18} height={18} color="white" />,
    },
    {
      path: "my-profile",
      label: "My Profile",
      icon: <ProfileIcon width={14} height={14} color="white" />,
    },
  ];

  if (authLoading)
    return (
      <div className="hayd-checkout-outer">
        <div className="hayd-checkout-inner w-[100vw] h-[100vh] overflow-hidden flex justify-center items-center bg-black">
          <div className="hayd-checkout-main relative max-w-[500px] w-[100%] h-[100%] bg-white rounded-xl overflow-hidden">
            <BootstrapLoader />
          </div>
        </div>
      </div>
    );

  if (!user) {
    return (
      <div className="w-[100vw] h-[100vh] bg-gray-100 p-4 flex items-center justify-center gap-4">
        <AccountLogin isProfile={true} />
      </div>
    );
  }

  return (
    <div className="w-[100vw] h-[100vh] bg-gray-100 p-4 flex items-start gap-4">
      <aside className="min-w-64 max-w-64 profile-main-container h-[100%] border border-gray-200 rounded-lg bg-slate-800 shadow-sm p-4">
        <div className="flex justify-center flex-col items-center">
          <div className="border-2 rounded-full w-24 h-24 flex justify-center items-center border-[#F9FAFB] bg-slate-800">
            <p className="text-3xl text-[#F9FAFB]">S</p>
          </div>
          <div className="mt-4 mb-12">
            <div className="text-center">
              <p className="text-[24px] supreme-medium text-[#F9FAFB] break-all">
                {user?.first_name === "HAYD_USER" ? "User" : user?.first_name}
              </p>
            </div>

            {user?.email && (
              <div className="text-center mt-3">
                <p className="text-[#F9FAFB] general-sans-medium break-all">
                  {user?.email}
                </p>
              </div>
            )}

            <div className="flex gap-5 mt-5 items-center justify-center">
              <div className="cursor-pointer">
                <a href="" target="_blank">
                  <FacebookIcon width={20} color="white" />
                </a>
              </div>
              <div className="cursor-pointer">
                <a href="" target="_blank">
                  <InstagramIcon width={20} color="white" />
                </a>
              </div>
              <div className="cursor-pointer">
                <a href="" target="_blank">
                  <YoutubeIcon width={20} color="white" />
                </a>
              </div>
              <div className="cursor-pointer">
                <a href="" target="_blank">
                  <PinterestIcon width={20} color="white" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <nav className="flex flex-col gap-3">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `text-left px-2 py-3 rounded-sm transition ${
                  isActive ? "bg-[#243B53]" : "hover:bg-[#2A3441]"
                }`
              }
            >
              {({ isActive }) => (
                <div className="flex items-center gap-2">
                  {item.icon}
                  <p
                    className={`text-[16px] text-white ${
                      isActive ? "supreme-bold" : "supreme-medium"
                    }`}
                  >
                    {item.label}
                  </p>
                </div>
              )}
            </NavLink>
          ))}
        </nav>

        <div className="mt-8 border-t-2 border-dashed">
          <button
            className={`text-left px-2 py-3 rounded-sm transition hover:bg-[#2A3441] w-[100%] mt-2`}
            onClick={() => {
              logout();
            }}
          >
            <div className="flex items-center gap-2">
              <ExitIcon width={18} color="white" />
              <p className={` text-[18px] supreme-medium text-white`}>Logout</p>
            </div>
          </button>
        </div>
      </aside>
      <main className="profile-main-container h-[100%] border border-gray-200 rounded-lg bg-white shadow-sm flex-1">
        <Outlet />
      </main>
    </div>
  );
};

export default Profile;
